// Lib
import React, { ReactElement } from 'react';

// Hooks
import { holdFocusWithoutKeyboard } from '../../../boardsPage/editing/touchScreenFocusUtils';
import useSheet from '../../../structural/sheet/hooks/useSheet';

// Components
import TextStyleRichTextTool from '../../../../workspace/toolbar/components/selectionTools/editorTools/TextStyleRichTextTool';
import MobileTextStyleSheetContent from './MobileTextStyleSheetContent';
import SheetContainer, { Content, Overlay, Sheet } from '../../../structural/sheet';
import { useGroupTranslator } from '../../../../components/i18n/GroupTranslationContext';

// Types
import { ImMNCurrentUser, MNCurrentUser } from '../../../../user/currentUserSelector';
import { ImMNElement } from '../../../../../common/elements/elementModelTypes';
import { SheetId } from '../../../structural/sheet/sheetTypes';

// Styles
import './MobileTextStyleRichTextTool.scss';

export type MobileTextStyleRichTextToolProps = {
    currentUser: ImMNCurrentUser | MNCurrentUser;
    currentUserId: string;
    currentBoardId: string;
    gridSize: number;
    gridSizeName: string;
    permissions: number;
    selectedElementIds: Immutable.List<string>;
    selectedElements: Immutable.List<ImMNElement>;
    editorKey: string;
    hasEditorSelection: boolean | undefined;
};

// FIXME-MOBILE - Add a style to the current editor to show the current selection
//  NOTE: Investigate whether it might be easier to do this using vanilla JS, so that we don't
//        accidentally save the selection state to the DB
const MobileTextStyleRichTextTool = (props: MobileTextStyleRichTextToolProps): ReactElement => {
    const sheetProps = useSheet(SheetId.TextStyleRichTextTool);
    const translate = useGroupTranslator();

    const onClickToolButton = () => {
        sheetProps.dispatchOpenSheet();
    };

    const textStyleText = translate('toolbar:mobile.textStyle', 'Text style');

    return (
        <div className="MobileTextStyleRichTextTool">
            <div onClick={onClickToolButton}>
                <TextStyleRichTextTool isOpen={sheetProps.isSheetOpen} name={textStyleText} />
            </div>
            <SheetContainer
                {...sheetProps}
                className="text-style-rich-text-tool"
                onCloseTransitionStart={holdFocusWithoutKeyboard}
            >
                <Overlay />
                <Sheet>
                    <Content>
                        <MobileTextStyleSheetContent {...props} />
                    </Content>
                </Sheet>
            </SheetContainer>
        </div>
    );
};

export default MobileTextStyleRichTextTool;
